import React from 'react';
import { MediumTitle, Card as MainCard } from '@indigo-ag/component-module';

import { createStylesHook } from 'shared/hooks/createStylesHook';

const useStyles = createStylesHook({
  cardContainer: {
    height: 'fit-content',
    marginBottom: 32,
    padding: '32px 24px'
  },
  cardTitle: {
    display: 'inline-block',
    paddingBottom: 24
  }
});

export interface CardProps {
  title?: string | JSX.Element;
  titleRightContent?: JSX.Element;
  topRightContent?: JSX.Element;
}

export const Card: React.FunctionComponent<CardProps> = ({ children, title, titleRightContent, topRightContent }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const renderTitle = () => {
    if (!title) {
      return null;
    }

    if (typeof title === 'string') {
      return <MediumTitle className={`text-transform-capitalize ${classes.cardTitle}`}>{title}</MediumTitle>;
    } else {
      return title;
    }
  };

  return (
    <MainCard className={classes.cardContainer}>
      <div className="flex flex-space-btw">
        <div>
          {renderTitle()}
          {titleRightContent ? titleRightContent : null}
        </div>
        {topRightContent ? <div>{topRightContent}</div> : null}
      </div>
      {children}
    </MainCard>
  );
};
